import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'

import { updateHospital, fetchHospitals } from '../../../../store/hospitals/actions'
import { fetchInstallations } from '../../../../store/installations/actions'
import { Edit } from './Edit'
import { IEditDispatchProps } from './types'
import { IState } from '../../../../store/types'
import { fetchPlans } from '../../../../store/plans/actions'
import { IEditStateProps } from './types'
import { IHospitalToUpdate } from '../../../../types/hospital'
import { fetchSubscriptions } from '../../../../store/subscriptions/actions'

const mapStateToProps = (state: IState): IEditStateProps => {
  return {
    hospitals: state.hospitals,
    installations: state.installations,
    subscriptions: state.subscriptions,
    plans: state.plans
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): IEditDispatchProps => {
  return {
    fetchHospitals: () => {
      return dispatch(fetchHospitals())
    },
    fetchSubscriptions: (hospitalId: string) => {
      return dispatch(fetchSubscriptions(hospitalId))
    },
    fetchInstallations: () => {
      return dispatch(fetchInstallations())
    },
    fetchPlans: () => {
      return dispatch(fetchPlans())
    },
    updateHospital: (hospital: IHospitalToUpdate) => {
      return dispatch(updateHospital(hospital))
    }
  }
}

const EditContainer = connect(mapStateToProps, mapDispatchToProps)(Edit)

export {
  EditContainer
}
